import { ACTIONS } from '../../constants';
import { IUserState, TUserActions } from './types';

const initialState: IUserState = {
  countryCode: '',
  id: '',
  profileImage: '',
};

export const userReducer = (
  state = initialState,
  action: TUserActions,
): IUserState => {
  switch (action.type) {
    case ACTIONS.SET_USER: {
      return {
        ...state,
        ...action.user,
      };
    }

    default: {
      return state;
    }
  }
};
